import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { FeedProductCard } from 'components/card'
import Image from 'components/image'
import HeartRating from 'components/heart-rating'
import PriceDisplay from 'store/components/price-display'
import { InfoButton } from 'components/buttons'
import Link from 'components/link'
import { DEFAULT_PRODUCT_IMAGE_PATH } from 'shared/constants'
import { ldGetFlag } from 'lib/launchDarkly/ldGetFlag'
import { StarRating } from 'baby-design'

const sizes = ['small', 'medium', 'large']

const sizeProp = PropTypes.oneOf(sizes)
sizeProp.values = sizes

class ProductTile extends PureComponent {
  static propTypes = {
    brand: PropTypes.string,
    image: PropTypes.string,
    path: PropTypes.string,
    price: PropTypes.object,
    rating: PropTypes.number,
    size: sizeProp,
    name: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
  }

  static defaultProps = {
    image: DEFAULT_PRODUCT_IMAGE_PATH,
  }

  state = {
    isSubmitting: false,
  }

  handleOnAdd = () => {
    this.setState({ isSubmitting: true })
    this.props.onAdd().then(() => this.setState({ isSubmitting: false }))
  }

  render() {
    const {
      brand,
      image,
      name,
      rating,
      reviewCount,
      price,
      isOnRegistry,
      path,
      size,
    } = this.props

    return (
      <FeedProductCard className={classNames('flex', { col: size == 'small' })}>
        <Link url={path} newWindow>
          <Image
            alt={name}
            src={image}
            className="img-responsive"
            lazyLoad={false}
          />
        </Link>

        <div className="flex grow col pam">
          <Link url={path} className="flex-grow" newWindow>
            <div
              className={classNames(
                'text-brand-info text-bold man',
                size == 'small' ? 'h7' : 'h6 mvs'
              )}
            >
              {brand}
            </div>
            <div
              className={classNames(
                'text-body man',
                size == 'small' ? 'h6' : 'h4 mvs'
              )}
            >
              {name}
            </div>
            <StarRating
              rating={rating}
              reviewCount={reviewCount}
              className="tiny flex mbl grow"
            />
          </Link>

          <div className="flex align-center">
            <div className="flex-grow flex col">
              <PriceDisplay
                price={price}
                priceClassName="xsmall"
                msrpClassName="xsmall mln"
              />
            </div>

            {!isOnRegistry ? (
              <InfoButton
                aria-label="Add"
                onClick={this.handleOnAdd.bind(this)}
                circle
                size="small"
                submitting={this.state.isSubmitting}
              >
                <Image
                  alt="add"
                  src="//images.babylist.com/image/upload/v1568653819/icn_add_fqc1nn.svg"
                />
              </InfoButton>
            ) : (
              <Image
                alt="success"
                src="//images.babylist.com/image/upload/v1568670049/icn_check_va95ym.svg"
              />
            )}
          </div>
        </div>
      </FeedProductCard>
    )
  }
}

export default ProductTile
